var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    clipRule: "evenodd",
    d: "M4 8.33334C4 3.73096 7.73096 0 12.3333 0H19.6667C24.269 0 28 3.73096 28 8.33333V23.6667C28 28.269 24.269 32 19.6667 32H12.3333C7.73096 32 4 28.269 4 23.6667V8.33334ZM12.3333 2C8.83553 2 6 4.83553 6 8.33334V23.6667C6 27.1645 8.83553 30 12.3333 30H19.6667C23.1645 30 26 27.1645 26 23.6667V8.33333C26 4.83553 23.1645 2 19.6667 2H12.3333ZM16 25C18.7614 25 21 22.7614 21 20C21 17.2386 18.7614 15 16 15C13.2386 15 11 17.2386 11 20C11 22.7614 13.2386 25 16 25ZM16 27C19.866 27 23 23.866 23 20C23 16.134 19.866 13 16 13C12.134 13 9 16.134 9 20C9 23.866 12.134 27 16 27ZM16.25 8C16.25 8.13807 16.1381 8.25 16 8.25C15.8619 8.25 15.75 8.13807 15.75 8C15.75 7.86193 15.8619 7.75 16 7.75C16.1381 7.75 16.25 7.86193 16.25 8ZM19 8C19 9.65685 17.6569 11 16 11C14.3431 11 13 9.65685 13 8C13 6.34315 14.3431 5 16 5C17.6569 5 19 6.34315 19 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.fb4c80918a1eed1b64fec5080fa47bc5.svg";
export { ForwardRef as ReactComponent };